'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.VatIdPattern = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Pattern2 = require('./Pattern');

var _ZipCodePattern = require('./ZipCodePattern');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VatIdPattern = exports.VatIdPattern = function (_Pattern) {
	_inherits(VatIdPattern, _Pattern);

	function VatIdPattern(cc) {
		_classCallCheck(this, VatIdPattern);

		var _this = _possibleConstructorReturn(this, (VatIdPattern.__proto__ || Object.getPrototypeOf(VatIdPattern)).call(this, ''));

		_this.setPatternByCountryCode(cc);
		return _this;
	}

	_createClass(VatIdPattern, [{
		key: 'setPatternByCountryCode',
		value: function setPatternByCountryCode(cc) {

			var vatid_pattern = {
				'AT': '^ATU[0-9]{8}$',
				'BE': '^BE0[0-9]{9}$|BE[0-9]{10}$',
				'BG': '^BG[0-9]{9,10}$',
				'CY': '^CY[0-9]{9}[A-Z]{1}$',
				'CZ': '^CZ[0-9]{8,10}$',
				'DE': '^DE[0-9]{9}$',
				'DK': '^DK[0-9]{8}$',
				'EE': '^EE[0-9]{9}$',
				'GR': '^EL[0-9]{9}$|GR[0-9]{9}$',
				'ES': '^ES[0-9A-Z][0-9]{7}[0-9A-Z]$',
				'FI': '^FI[0-9]{8}$',
				'FR': '^FR[0-9A-Z]{2}[0-9]{9}$',
				'GB': '^GB[0-9]{9}$|GB[0-9]{12}$|GBGD[0-9]{3}$|GBHA[0-9]{3}$',
				'HR': '^HR[0-9]{11}$',
				'HU': '^HU[0-9]{8}$',
				'IT': '^IT[0-9]{11}$',
				'IE': '^IE[0-9][A-Z0-9][0-9]{5}[A-Z]$|IE[0-9]{7}[A-W][A-I]$',
				'LT': '^LT([0-9]{9}|[0-9]{12})$',
				'LU': '^LU[0-9]{8}$',
				'LV': '^LV[0-9]{11}$',
				'MT': '^MT[0-9]{8}$',
				'NL': '^NL[0-9]{9}B[0-9]{2}$',
				'PL': '^PL[0-9]{10}$',
				'PT': '^PT[0-9]{9}$',
				'RO': '^RO[0-9]{2,10}$',
				'SE': '^SE[0-9]{12}$',
				'SI': '^SI[0-9]{8}$',
				'SK': '^SK[0-9]{10}$'
			};

			this.reg = new RegExp(vatid_pattern[cc]);
		}
	}]);

	return VatIdPattern;
}(_Pattern2.Pattern);